import { ScaledSize } from '../styles'

export default class {
    public static onAndroid = false
    public static onIOS = false
    public static isNative = false
    public static isNextJS: boolean

    public static getDimensions(): ScaledSize {
        return {
            width: typeof document !== 'undefined' ? document.documentElement.clientWidth : 0,
            height: typeof document !== 'undefined' ? document.documentElement.clientHeight : 0,
            scale: typeof window !== 'undefined' ? window.devicePixelRatio : 1,
            fontScale: 1,
        }
    }

    public static getPixelSizeForLayoutSize(layoutSize: number): number {
        return Math.round(layoutSize * this.getDimensions().scale)
    }
}
